<template>
  <div>
    <h1 class="indigo--text">Reactivos</h1>
    <v-layout wrap>
      <v-flex sm12>
        <v-form ref="form">
          <v-text-field
            v-model="searchString"
            solo
            label="Buscar Reactivos"
            prepend-inner-icon="mdi-magnify"
            background-color="grey lighten-3"
          ></v-text-field>
        </v-form>
      </v-flex>
      <v-fab-transition>
        <v-btn
          @click="dialog = true"
          style="position:fixed;right:10px;bottom:10px;z-index:100"
          class="primary"
          fab
          large
          dark
          bottom
          right
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-layout>

    <div v-if="reactives.length > 0">
      <ReactiveCard
        v-for="(reactive, index) in search"
        :key="index"
        :reactive="reactive"
        @updateReactive="getReactives"
        :aspectsProp="aspects"
      ></ReactiveCard>
    </div>
    <div v-else>
      <p>Aún no hay reactivos en la plataforma</p>
    </div>

    <!-- Ventana para crear reactivo -->
    <v-dialog v-model="dialog" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Crear Reactivo</v-card-title>

        <v-form ref="form" @submit.prevent="send">
          <v-container>
            <v-layout wrap>
              <v-flex sm12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="title" label="Reactivo" :rules="requiredRule"></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field v-model="timer" label="Cronómetro"></v-text-field>
                  </v-flex>

                  <v-select
                    :items="aspects"
                    item-text="title"
                    v-model="aspect"
                    return-object
                    label="Aspecto"
                  ></v-select>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false">cancelar</v-btn>
            <v-btn color="primary" text type="submit">Crear</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import ReactiveCard from "@/components/ReactiveCard";
export default {
  components: {
    ReactiveCard
  },
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      searchString: "",
      reactives: [],
      timer: null,
      title: "",
      aspects: [],
      snackbar: false,
      message: "",
      aspect: {},
      dialog: false,
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    getAspects() {
      axios
        .get(this.host + "/aspects/onlyaspects.php")
        .then(response => {
          this.aspects = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getReactives() {
      axios
        .get(this.host + "/reactives/read.php")
        .then(response => {
          this.reactives = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    send() {
      if (this.$refs.form.validate()) {
        let data = {
          title: this.title,
          timer: this.timer || 0,
          idAspect: this.aspect.idAspect,
          idUserVerify: sessionStorage.getItem("authorization")
        };

        axios
          .post(this.host + "/reactives/create.php", this.createFormData(data))
          .then(response => {
            this.dialog = false;
            this.message = response.data.message;
            this.snackbar = true;
            this.getReactives();
            this.title = "";
            this.timer = null;
            this.aspect = {};
            this.$refs.form.resetValidation();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.getReactives();
    this.getAspects();
    //console.log(sessionStorage.getItem("authorization"))
  },
  computed: {
    search() {
      return this.reactives.filter(item =>
        item.title.toLowerCase().includes(this.searchString.toLowerCase())
      );
    }
  }
};
</script>